import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Hash } from "lucide-react";

const preview = (f) => `${f.prefix || ""}${(f.next_number || "").trim() || "1"}${f.suffix || ""}`;

export default function ProjectIdSettings() {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings/project-id").then(({ data }) => setForm({
      prefix: data.prefix || "", suffix: data.suffix || "",
      next_number: String(data.next_number).padStart(data.pad_width || 1, "0"),
    })).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/settings/project-id", form);
      toast.success(`Saved — next project will be ${data.preview}`);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };

  if (!form) return null;
  return (
    <form onSubmit={save} className="border border-neutral-200 bg-white p-6 space-y-3 rounded-2xl" data-testid="project-id-settings">
      <div className="label-caps flex items-center gap-2"><Hash size={12} /> Project ID Format</div>
      <p className="text-xs text-neutral-500">Applies to newly created projects only. Existing Project IDs never change.</p>
      <div className="grid grid-cols-3 gap-3">
        <div><label className="label-caps block mb-1">Prefix</label>
          <Input data-testid="pid-prefix" value={form.prefix} onChange={(e) => setForm({ ...form, prefix: e.target.value })} placeholder="DRMPRJ-" className="rounded-lg border-black/15" /></div>
        <div><label className="label-caps block mb-1">Next Number</label>
          <Input data-testid="pid-next-number" required inputMode="numeric" pattern="\d+" value={form.next_number} onChange={(e) => setForm({ ...form, next_number: e.target.value.replace(/\D/g, "") })} placeholder="0001" className="rounded-lg border-black/15 font-mono-tight" /></div>
        <div><label className="label-caps block mb-1">Suffix</label>
          <Input data-testid="pid-suffix" value={form.suffix} onChange={(e) => setForm({ ...form, suffix: e.target.value })} placeholder="-2026" className="rounded-lg border-black/15" /></div>
      </div>
      <div className="text-xs text-neutral-500">Leading zeros set the width (0001 → 0002 … 0010). Next ID: <span className="font-mono-tight font-semibold text-ink" data-testid="pid-preview">{preview(form)}</span></div>
      <button data-testid="pid-save" disabled={busy} className="btn-primary disabled:opacity-50">{busy ? "Saving…" : "Save Project ID Format"}</button>
    </form>
  );
}
